export const initiative_doc_template = {
  ops: [
    {
      insert: 'Customer',
    },
    {
      attributes: {
        header: 1,
      },
      insert: '\n',
    },
    {
      insert: 'Who is the customer?',
    },
    {
      attributes: {
        header: 2,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 Write down in 1 sentence who the customer is. The sentence should help you get that person on the phone or find the person on the street.',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\nWhat is the customer problem or opportunity?',
    },
    {
      attributes: {
        header: 2,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 To get started, fill in the following template for each defined customers.',
    },
    {
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert: 'TODAY ',
    },
    {
      attributes: {
        italic: true,
        bold: true,
      },
      insert: '(customer type)',
    },
    {
      attributes: {
        italic: true,
      },
      insert: '______________ HAVE/HAS TO ',
    },
    {
      attributes: {
        italic: true,
        bold: true,
      },
      insert: '(problem or opportunity)',
    },
    {
      attributes: {
        italic: true,
      },
      insert: '_______________ WHEN ',
    },
    {
      attributes: {
        italic: true,
        bold: true,
      },
      insert: '(situation)',
    },
    {
      insert: '____________\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\nHow do you know what customers need or want?',
    },
    {
      attributes: {
        header: 2,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 What did you do to validate the problem? For example: questionnaires, prototypes, personal experiences. If possible, please provide metrics that help you size the need of customers.',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\n',
    },
    {
      insert: {
        hr: true,
      },
    },
    {
      attributes: {
        header: 1,
      },
      insert: '\n',
    },
    {
      insert: 'Measure Success',
    },
    {
      attributes: {
        header: 1,
      },
      insert: '\n',
    },
    {
      insert: 'How ',
    },
    {
      attributes: {
        token: 'keyword',
      },
      insert: 'do',
    },
    {
      insert: ' you measure success?',
    },
    {
      attributes: {
        header: 2,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 What metrics would you look at that indicate success? Please provide metrics that are close to your product or idea. Ideally metrics that indicate that you solved your customers problem and/or metrics that indicate feature usage.',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\n',
    },
    {
      insert: {
        hr: true,
      },
    },
    {
      attributes: {
        header: 1,
      },
      insert: '\n',
    },
    {
      insert: 'Solution',
    },
    {
      attributes: {
        header: 1,
      },
      insert: '\n',
    },
    {
      insert: 'What solution do you offer?',
    },
    {
      attributes: {
        header: 2,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 Please write 1 to 3 paragraphs describing the solution to the customer problem stated above. The trick is to capture the essence of your idea in 2 or 3 paragraphs. ',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\nWhat does the solution look like?',
    },
    {
      attributes: {
        header: 2,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 Please provide an 8 to 12 panel “comic strip” or “story board” of how customers would experience your solution. ',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\n',
    },
    {
      insert: {
        hr: true,
      },
    },
    {
      insert: '\nPlanning & Team',
    },
    {
      attributes: {
        header: 1,
      },
      insert: '\n',
    },
    {
      insert: 'What is the expected timeline of the project?',
    },
    {
      attributes: {
        header: 2,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 In case of a project running 3+ months, please provide 1 core achievement per month. In case of a project measures < 12 weeks. Please provide a key achievement per week.',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\nAre there time critical events on the horizon?',
    },
    {
      attributes: {
        header: 2,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 Will there be any events or activities in the near future that provide hard limits or big opportunities for the success of your initiative? Are customers about to churn? Is there a big faire or event for sales coming up?',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert:
        '\nWhat is the relationship between this project and other projects?',
    },
    {
      attributes: {
        header: 2,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 Are there dependencies that need to be delivered before this project can be released? Are there any related projects that add or remove risks for this project?',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\nWhat does the team look like that is going to make it happen?',
    },
    {
      attributes: {
        header: 2,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 Write down the roles you need to have in your team and describe what these roles are responsible for. ',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\n',
    },
    {
      insert: {
        hr: true,
      },
    },
    {
      insert: '\nInitiative',
    },
    {
      attributes: {
        header: 1,
      },
      insert: '\n',
    },
    {
      insert: 'What is your Addressable Market or Customer Segment?',
    },
    {
      attributes: {
        header: 2,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 In case of a full product launch: what is the total addressable market in terms of users and revenue. In case of a feature or beta launch: what is the customer segment size you are targeting with the feature or beta.',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\nWhat is the budget of the project?',
    },
    {
      attributes: {
        header: 2,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 If possible, express your budget in euros, if that is not possible please express the budget in terms of person weeks.',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\n',
    },
    {
      insert: {
        hr: true,
      },
    },
    {
      insert: '\nWhat is the back of a napkin Initiative behind the project?',
    },
    {
      attributes: {
        header: 1,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 Please provide a rough calculation of the Initiative behind the project. This can be done in 1 or 2 paragraphs. A more extensive Initiative calculation can be added as an appendix to this document if necessary.',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\n',
    },
    {
      insert: {
        hr: true,
      },
    },
    {
      insert: '\nInternal F.A.Q.',
    },
    {
      attributes: {
        header: 1,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 Please list all questions, simple, complex, difficult or easy that people internal to your company might ask. It is ok to ask questions to which you don’t have answers (yet). Asking people for feedback on this document, and adding their questions to the FAQ is a good idea.',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\n',
    },
    {
      insert: {
        hr: true,
      },
    },
    {
      insert: '\nExternal F.A.Q.',
    },
    {
      attributes: {
        header: 1,
      },
      insert: '\n',
    },
    {
      attributes: {
        italic: true,
      },
      insert:
        '👉 What will your customer ask? Imagine a customer hearing about what you intend to do for them, what would they ask?',
    },
    {
      insert: '\nType here...',
    },
    {
      attributes: {
        list: 'bullet',
      },
      insert: '\n',
    },
    {
      insert: '\n',
    },
  ],
};
